import { render, staticRenderFns } from "./custom-dropdown.vue?vue&type=template&id=8386bc8a&"
import script from "./custom-dropdown.vue?vue&type=script&lang=tsx&"
export * from "./custom-dropdown.vue?vue&type=script&lang=tsx&"
import style0 from "./custom-dropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports